<app-alerts></app-alerts>

<div  *ngIf="!loading; else load" class="row">
	<div *ngIf="stat" class="col-12">

<div class="row">
<div class="col-12">
		<div class="topPanel">
 
			<div>
				<div  style="margin-right: 50px;"  (click)="openClearDialog()"  class="item"><nb-icon [color]="'danger'"  [icon]="'trash'" pack="eva"></nb-icon></div>
				
				<div  (click)="refresh()" class="item"><nb-icon [icon]="'refresh-outline'" pack="eva"></nb-icon></div></div>
		</div>
</div>

</div>

<div class="row">
<div class="col-12">
		<h5 class="mainTitle">{{stat.title}}</h5>
</div>

</div>
 		

		<div class="row">
			<div class="col-12 col-sm-6 col-md-6 col-md-6 col-lg-3 statColumn">

			<div class="statItem statItemSquare statItemRectMin">
				<div class="statItemHead">Візити</div>
				<div  class="statItemBigMetric">{{stat.visits.all}}</div>
				 
			</div> 
		</div>
			<div class="col-12 col-sm-6  col-md-6 col-lg-3 statColumn">

			<div  class="statItem statItemSquare statItemRectMin">
				<div class="statItemHead">Унікальні візити</div>
				<div  class="statItemBigMetric">{{stat.uniqueVisits.all}}</div>
				 
			   </div>

			</div>

			 <div class="col-12  col-md-12 col-lg-6 statColumn">


			 
			 <div class="statItem statItemRect statItemRectMin accessBlock"> 
					<div class="abHead">Відкрити доступ за посиланням</div>
					<div class="abContent">
						<div class="wrp">
						  <div class="cnt"><div  *ngIf="!stat.publish">Доступ закритий</div>
							<div  *ngIf="stat.publish">
								<a target="_blank" [href]="'/stat/'+stat._id">{{openLink}}</a>

							</div>

						   </div>

						  <div  *ngIf="stat.publish" class="lnk"><a    (cbOnSuccess)="showToastCopyClipboard('Скопійовано в буфер обміну')"   ngxClipboard [cbContent]="openLink" href="javascript:;">Скопіювати публічне посилання</a></div>
						</div>

						<div  class="wrpBtn"> 
							<!-- Закрыть доступ  -->
							<div *ngIf="!stat.publish"><button [disabled]="publishDisabled" (click)="setPublish(true)"  nbButton fullWidth status="primary">Відкрити доступ</button></div>
							<div *ngIf="stat.publish"><button [disabled]="publishDisabled" (click)="setPublish(false)"   nbButton fullWidth status="basic">Закрити доступ</button></div>
						</div>


					</div> 
			 </div>

			</div>
		</div> 

<div class="row">
			<div class="col-12 col-sm-6  col-md-6 col-lg-3 statColumn">

			<div class="statItem statItemSquare statItemRectMin">
				<div class="statItemHead">Перегляд</div>
				<div  class="statItemBigMetric">{{stat.visits.live + stat.visits.vod}}</div>
				  

				<div  class="bottomMetrics"><span class="label">Ефір</span> <span class="num">{{stat.visits.live}}</span></div>
				<div class="bottomMetrics"><span class="label">Запис</span> <span class="num">{{stat.visits.vod}}</span></div>
		
				 
			</div> 
		</div>
			<div class="col-12 col-sm-6  col-md-6 col-lg-3 statColumn">

			<div  class="statItem statItemSquare statItemRectMin">
				<div class="statItemHead">Унікальні перегляди</div>
				<div  class="statItemBigMetric">{{stat.uniqueVisits.live + stat.uniqueVisits.vod}}</div>
				 
				<div  class="bottomMetrics"><span class="label">Ефір</span> <span class="num">{{stat.uniqueVisits.live}}</span></div>
				<div class="bottomMetrics"><span class="label">Запис</span> <span class="num">{{stat.uniqueVisits.vod}}</span></div>
		
				 
			   </div>

			</div>

			 <div class="col-12 col-sm-6  col-md-6 col-lg-3 statColumn">

	<div  class="statItem statItemSquare">
				<div class="statItemHead">Середній час</div>
				<div  class="statItemBigMetric">{{stat.watchTime || 0}}</div>
				<div  class="bottomMetrics"><span class="label">Ефір</span> <span class="num">{{stat.liveTime || 0}} хв.</span></div>
				<div   class="bottomMetrics"><span class="label">Запис</span> <span class="num">{{stat.vodTime || 0}} хв.</span></div>		 	

		</div>
 
			</div>
 
			

			 <div class="col-12 col-sm-6  col-md-6 col-lg-3 statColumn">

<div class="statItem statItemSquare  ">
				<div class="statItemHead">Актив. ключі</div>
				<div  class="statItemBigMetric">{{stat.keysUsedCount}}</div>
				
			<div style="width:auto;margin: auto;margin-top: -2px;" class="bottomMetrics"><span class="label">з</span> <span  style="margin-left:5px" class="num">{{stat.keysCount}}</span></div>
				<div style="margin-top:12px"  class="bottomMetrics">  <button [disabled]="!stat?.keysCount" (click)="openKeysModal()" nbButton fullWidth outline status="primary">	Детальніше</button></div>
			</div>
			 

			</div>




		</div> 



		<div class="row">

			 <div class="col-12 col-md-6 col-lg-6 statColumn">
			 <div class="statItem statItemRect"> 
				<h6>Країна</h6>
 
				
				<div class="stat-table">
				<div class="stat-table-head">
					<div class="right"><div>Перегляди</div><div>Унік.</div></div>
				</div>
				<div class="stat-table-content scrollable-container">
				
				
				<div class="stat-table-row" *ngFor="let item of stat.contries">

				<div class="left">{{item.country}}</div>

				<div class="right"><div>{{item.vis}} </div><div>{{item.uniq}} </div></div>
 
				</div>
			 

				</div>


				</div>
	

			</div>

			</div>
		

			 <div class="col-12  col-md-6  col-lg-6 statColumn">
			 <div class="statItem statItemRect"> 

				<h6>Місто</h6>

				<div class="stat-table">
				<div class="stat-table-head">
					<div class="right"><div>Перегляди</div><div>Унік.</div></div>
				</div>
					<div class="stat-table-content  scrollable-container">
				
					<div class="stat-table-row" *ngFor="let item of stat.cities">

					<div class="left">{{item.city}}</div>

					<div class="right"><div>{{item.vis}} </div><div>{{item.uniq}} </div></div>
	 

					</div>
				</div>

				</div>

			</div>

			</div>
		</div>

 
	</div>

</div>


<ng-template #load>


   <app-skeleton-page   [type]="'inner-stat'" ></app-skeleton-page>

    
</ng-template> 


<ng-template #clearModal  let-data   let-ref="dialogRef">

	<div style="max-width:400px">
		   <nb-card>
		<nb-card-header>
	
	  
	  <div style="display:flex; width:100%">
		 
		 <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="ref.close()">
  <nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
	  </span>  
	  </div>
	</nb-card-header>
		<nb-card-body>
	  <div>
		  
		   
		<p>Очистити статистику?</p>
	
	  </div>
	</nb-card-body>
		<nb-card-footer>
		 
		   
	  <div style="display:flex; width:100%">
			  
			  <button style="display:flex; margin-left:auto; cursor: pointer;" (click)="clear(ref)" nbButton status="danger" >Підтвердити  </button>
			  <button style="display:flex; margin-left:15px; cursor: pointer;" (click)="ref.close()" nbButton status="basic" >Скасувати</button>
  
	
			</div>
		</nb-card-footer>
	  </nb-card>
	   
	</div>
	  </ng-template>